import React, { useState } from "react";
import { AlertDialog } from "react-onsenui";
import { useTranslation } from "react-i18next";

export default function Dialog(props) {
  const { visible, setVisible ,title,desc,onConfirm} = props;
 const { t } = useTranslation();
  return (
    <AlertDialog isOpen={visible} isCancelable={false}>
      <div className="alert-dialog-title">{title || "TITLE"}</div>
      <div className="alert-dialog-content">{desc || "DESC"}</div>
      <div className="alert-dialog-footer">
        <button
          onClick={() => setVisible(false)}
          className="alert-dialog-button"
        >
          {t('Cancel')}
        </button>
        <button
          onClick={() => {setVisible(false); onConfirm()}}
          className="alert-dialog-button"
        >
          {t('Confirm')}
        </button>
      </div>
    </AlertDialog>
  );
}
